module.exports = __webpack_public_path__ + "img/tz.91e6c6c1.svg";